import {createAsyncStoragePersister} from '@tanstack/query-async-storage-persister';
import {QueryClient} from '@tanstack/react-query';

import {PERSIST_QUERY_CLIENT_KEY} from './constants.js';

export const queryClient = new QueryClient();

export function createPersister() {
  return createAsyncStoragePersister({
    storage: window.localStorage,
    key: PERSIST_QUERY_CLIENT_KEY,
  });
}
